// src/Pages/VideoIntro.js
import React, { useMemo } from 'react';
import { useNavigate } from 'react-router-dom';
import introVideo from '../Assets/Videos/esipro2.mp4';
import logoVideo from '../Assets/Videos/bozza_video.mp4';

export default function VideoIntro() {
    const navigate = useNavigate();

    // First visit of the session → esipro2.mp4, subsequent (logo click) → bozza_video.mp4
    const isFirstVisit = useMemo(() => {
        const visited = sessionStorage.getItem('site_visited');
        if (!visited) {
            sessionStorage.setItem('site_visited', '1');
            return true;
        }
        return false;
    }, []);

    const videoSrc = isFirstVisit ? introVideo : logoVideo;

    const goToHome = () => navigate('/home');

    return (
        <div
            style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100vw',
                height: '100vh',
                backgroundColor: '#000',
                zIndex: 9998,
                cursor: 'pointer',
            }}
        >
            <video
                key={videoSrc}
                src={videoSrc}
                autoPlay
                muted
                playsInline
                onEnded={goToHome}
                onClick={goToHome}
                style={{
                    position: 'absolute',
                    top: 0,
                    left: 0,
                    width: '100%',
                    height: '100%',
                    objectFit: 'cover',
                }}
            />
        </div>
    );
}
